module.exports = __webpack_public_path__ + "media/images/responsive/costumes/category_icons/dress/color-3268cf392a98d7688669ee3d5e53fae4.jpg";